import React, { useState } from 'react'
import ClassHeader from './ClassHeader'
import ClassFooter from './ClassFooter'

const ClassLayout = ({ children, pc, localStream, remoteVideo, localVideo, socket }) => {
  const [mute, setMute] = useState(true)
  const [video, setVideo] = useState()
  return (
    <div
      className="px-[2%] py-4 flex flex-col  justify-between"
      style={{ height: 'calc(100vh - 50px)' }}
    >
      <ClassHeader mute={mute} setMute={setMute} video={video} setVideo={setVideo} />
      {children}
      <ClassFooter
        pc={pc}
        localStream={localStream}
        remoteVideo={remoteVideo}
        localVideo={localVideo}
        socket={socket}
      />
    </div>
  )
}

export default ClassLayout
